class JsonTxnBuilder {
  static build(type, slice, attrs) {
    return {
      type,
      attrs: {
        from: attrs.from,
        to: attrs.to,
        ...(attrs.structure && { structure: attrs.structure }),
        data: [
          {
            ...(slice?.content && {
              content: slice.content,
            }),
            openStart: slice?.openStart,
            openEnd: slice?.openEnd,
          },
        ],
      },
    };
  }
}
export { JsonTxnBuilder };
